export default {
  BASE_URL: '/psm/decoration/engin',
  api: [
    {
      name: 'pageLabel',
      method: 'GET',
      desc: '管理后台页签信息',
      path: '/admin/page/info'
    },
    {
      name: 'list',
      method: 'GET',
      desc: '后台申报列表',
      path: '/admin/list'
    },
    {
      name: 'audit',
      method: 'PUT',
      desc: '申报详情审核',
      path: '/admin/audit'
    },
    {
      name: 'detail',
      method: 'GET',
      desc: '申报详情',
      path: '/detail'
    },
    {
      name: 'quit',
      method: 'PUT',
      desc: '退出申报',
      path: '/quit'
    },
    {
      name: 'review',
      method: 'PUT',
      desc: '评审申报',
      path: '/admin/review'
    },
    {
      name: 'export',
      method: 'POST',
      desc: '导出申报',
      path: '/admin/export'
    },
    {
      name: 'issue',
      method: 'PUT',
      desc: '发证',
      path: '/admin/issue/{id}'
    },
    {
      name: 'updateAssess',
      method: 'PUT',
      desc: '修改评审结果',
      path: '/admin/update'
    },
    {
      name: 'batchUpdate',
      desc: '分组信息批量更新',
      method: 'POST',
      path: '/admin/group/batchUpdate'
    },
    {
      name: 'update',
      desc: '编辑申报单',
      method: 'POST',
      path: '/admin/update'
    },
    {
      name:'categories',
      desc:'工程类别',
      method:'GET',
      path:'/categories'
    },
    {
      name:'getTableData',
      desc:'申报表格数据',
      method:'GET',
      path:'/admin/getTableData'
    },
    {
      name:'getStatisticsByYears',
      desc:'历史申报年度统计表',
      method:'GET',
      path:'/admin/getStatisticsByYears'
    },
    {
      name:'getHistogramData',
      desc:'申报表格数据-柱状图',
      method:'GET',
      path:'/admin/getHistogramData'
    },
    {
      name:'getPieChartData',
      desc:'申报表格数据-饼图',
      method:'GET',
      path:'/admin/getPieChartData'
    },
    {
      name:'exportCurrentData',
      desc:'表格数据-导出',
      method:'GET',
      path:'/admin/exportCurrentData'
    },
    {
      name:'exportStatisticsByYears',
      desc:'历史申报年度统计表-导出',
      method:'GET',
      path:'/admin/exportStatisticsByYears'
    },
    {
      name:'batchReview',
      desc:'批量评审',
      method:'POST',
      path:'/admin/batchReview'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/api/psm/ead/index.js